import * as React from 'react';
import { BarChart } from "./BarChart";
import { ChartData, ChartDataContext } from "../context/Chart";
import { generateRandomRgb } from "../util/color";


const LABEL = 'Resultaten hoofdstukken';

const convertResultsetToChartData = (data: ChartData) : Chart.ChartData => {

    const filteredData = data.result_set.filter((result_set) => result_set.passed_threshold);

    const colors = filteredData.map(() => {
        return generateRandomRgb();
    });

    return {
        labels: filteredData[0].chapter.map(function(c){
            return c.title;
        }),
        datasets: filteredData.map( function( result_set ) {
            return result_set.chapter.map (function(chapter){
                return Math.round(chapter.average_score.average)/10;
            });
        }).map( function ( data_set, index ) {
            return {
                label: filteredData[index].title,
                data : data_set,
                backgroundColor: colors[index],
                borderWidth: 0,
                barPercentage: 1,
                maxBarThickness: 10
            };
        })
    }
}

export const ChaptersChart = () : JSX.Element => {
    const [data,] = React.useContext(ChartDataContext);
    const [chaptersData,setChaptersData] = React.useState<any>(convertResultsetToChartData(data));

    React.useEffect(() => {
        if(!data.fetching&&!data.fetch){
            setChaptersData(convertResultsetToChartData(data))
        }
    },[data]);

    const options = {
        scales: {
            x: {
                minBarLength: 2,
                gridLines: {
                    offsetGridLines: true
                },
                ticks: {
                    font: {
                        size: 10
                    }
                }
            },
            y: {
                ticks: {
                    max: 10,
                    min: 0,
                    stepSize: 1
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                position: 'right' as any
            }
        }
    };

    return <div className={'c-rstats__charts'}>
        <h2>{LABEL}</h2>
        <BarChart data={chaptersData} options={options} label={LABEL} />
    </div>;
}
